import { getByPath, setByPath } from "../../../../dot-notation/index.js";
import { produce } from "../../../../immer/index.js";
import { createProperty } from "../../utils/createProperty.js";
function createFieldPrivateApi(store, getLogger, getSubscribersApi, refreshFormStatus) {
  const { notifyFieldSubscriber, notifyFormSubscribers, notifyMetaSubscribers } = getSubscribersApi();
  const privateFieldApi = {
    tryToCreateField: (fieldName, fallbackValue) => {
      if (typeof fieldName !== "string") throw new Error('".tryToCreateField()" expects a "string" as identifier.');
      if (fieldName.trim().length === 0)
        throw new Error('".tryToCreateField()" do not accept an empty string as field name.');
      const log = getLogger();
      const existingField = store.fields[fieldName];
      if (existingField !== void 0) return existingField;
      log(`Dynamic creation of the field: "${fieldName}"`);
      store.fields = produce(store.fields, (draft) => {
        let resetFieldValue;
        let fieldValue;
        try {
          fieldValue = getByPath(store.values, fieldName);
        } catch (e) {
        }
        try {
          resetFieldValue = getByPath(store.initialValues, fieldName);
        } catch (e) {
        }
        if (fallbackValue !== void 0 && fieldValue === void 0) {
          fieldValue = fallbackValue;
        }
        const draftFieldName = fieldName;
        const fieldType = Array.isArray(fieldValue) ? "arrayField" : "field";
        draft[draftFieldName] = {
          type: fieldType,
          value: fieldValue,
          resetValue: resetFieldValue,
          visible: true,
          disabled: false,
          required: false,
          validating: false,
          status: "indeterminate"
        };
      });
      store.values = produce(store.values, (draft) => {
        const fieldPath = fieldName;
        const val = store.fields[fieldName]?.value;
        if (val !== void 0) {
          try {
            setByPath(draft, fieldPath, val);
          } catch (e) {
            createProperty(draft, fieldPath, val);
          }
        }
      });
      notifyFieldSubscriber(fieldName);
      refreshFormStatus();
      notifyMetaSubscribers();
      notifyFormSubscribers();
      const field = store.fields[fieldName];
      if (field === void 0) {
        throw new Error('".tryToCreateField()" Something went wrong trying to dynamically create a new field ');
      }
      return field;
    }
  };
  return privateFieldApi;
}
export {
  createFieldPrivateApi
};
//# sourceMappingURL=createFieldPrivateApi.js.map
